const onlyNumber = function (e) {
    var onlyNumRegex = /^[1-9][0-9]*$/;
    if (e != null) {
        if ((e.type=='keydown') && !onlyNumRegex.test(e.target.value)) {
            e.target.value = '';
        }
        // Allow: backspace, delete, tab, escape, enter and .
        if ([46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A,Ctrl+C,Ctrl+V, Command+A
            ((e.keyCode == 65 || e.keyCode == 86 || e.keyCode == 67) && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    }
    else {
        return true;
    }
}
const onlyCharSpace = function(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if( charCode ==32 )
    {
        return true;
    }
    if ( charCode > 31 && (charCode < 65 || charCode > 90) && (charCode < 37 || charCode > 40) && charCode != 46 ) {
        evt.preventDefault();
    } else {
        return true;
    }
}

const alphaNumericSpace = function(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode; 
    if( charCode == 32 )
    {
        return true;
    }
    else if (charCode > 31  && (charCode < 65 || charCode > 90) && (charCode < 37 || charCode > 40) && charCode != 46) {
        if ((evt.shiftKey || (charCode < 48 || charCode > 57)) && (charCode < 96 || charCode > 105)){
            evt.preventDefault();
        } 
    } 
    else {
        return true;
    }
}

const isFloat = function (floatObj) {
    if (floatObj == null || floatObj == '') {
        return false;
    }
    return true;
}

const checkError = function(obj, code, getSavedQuoteData){
    let mechanism = []
    let ret = false;
    if(!ret && obj.parameterName == 'Geographical extension' && code=='IMT1'){
        //Geographical extension check
        // if(obj.countrySelectedList.length == 0){
        //     obj.errorText = obj.errorMessage;
        //     ret = true;
        // }else{
            obj.errorText = '';
        // }
    }
    else{
        if(!ret && (obj.value=='' || obj.value==null)){
            if(obj.isMandatory){
                obj.errorText=obj.message[0];
                ret = true;
            }
        }else if(!ret && obj.value == 0 && obj.parameterName !== 'Rally Period Excess'){
            obj.value = '';
            if(obj.isMandatory){
                obj.errorText=obj.message[0];
                ret = true;
            }
        }
        else{
            obj.errorText = '';
            if(obj.validation.length > 0){
                for(let i = 0; i<obj.validation.length; i++){
                    mechanism = [];
                    if(!ret && obj.validation[i] == 'onlyNumber'){
                        mechanism.push('onlyNumber');
                    }
                    if(!ret && obj.validation[i] == 'monthRange'){
                        mechanism.push('monthRange');
                    }
                    if(!ret && obj.validation[i] == 'sumOfTrailer'){
                        mechanism.push('sumOfTrailer');
                    }
                    if(!ret && obj.validation[i] == 'checkPercentage'){
                        mechanism.push('checkPercentage');
                    }
                    if(!ret && obj.validation[i] == 'carryingCapacity'){
                        mechanism.push('carryingCapacity');
                    }
                    if(!ret && obj.validation[i] == 'minimumValueSix'){
                        mechanism.push('minimumValueSix');
                    }
                    if(!ret && obj.validation[i] == 'alphanumeric'){
                        mechanism.push('alphanumeric');
                    }
                    if(!ret && obj.validation[i] == 'multipleTenThousand'){
                        mechanism.push('multipleTenThousand');
                    }
                    if(!ret && obj.validation[i] == 'validateRange'){
                        mechanism.push('validateRange');
                    }
                    if(!ret && obj.validation[i] == 'onlyCharSpace'){
                        mechanism.push('onlyCharSpace');
                    }
                    if(!ret && obj.validation[i] == 'checkPercentage'){
                        mechanism.push('checkPercentage');
                    }
                    if(!ret && obj.validation[i] == 'validateMandatory'){
                        mechanism.push('validateMandatory');
                    }
                    if (!ret && mechanism[0] == 'validateMandatory') {
                        if (obj.value) {
                            obj.errorText = obj.message[i+1];
                            ret = true;
                        }
                        else {
                            obj.errorText = '';
                        }
                    }
                    // Trailer Value Max Length check
                    if (!ret && mechanism[0] == 'sumOfTrailer') {
                        if (obj.value && obj.errorMessageMaxLength!=='') {
                            obj.errorText = obj.errorMessageMaxLength;
                            ret = true;
                        }
                        else {
                            obj.errorText = '';
                        }
                    }
                    //check for number percentage only
                    if (!ret && mechanism[0] == 'checkPercentage') {
                        //var numperChecker = /^(\d\d?(\.\d\d?)?|100(\.00?)?)$/;
                        // if (obj.value && obj.errorMessageAllocationPercentage!=='') {
                        //     obj.errorText = obj.errorMessageAllocationPercentage;
                        //     ret = true;
                        //     // if (!numperChecker.test(obj.value)) {
                        //     //     obj.errorText = 'Valid Percentage is required';
                        //     //     ret = true;
                        //     // }
                        //     // else {
                        //     //     obj.errorText = '';
                        //     // }
                        // }
                        // else {
                        //     obj.errorText = '';
                        // }
                    }
                    //check for number only
                    if(!ret && mechanism[0] == 'onlyNumber'){
                        var numChecker =/^[0-9]*$/;
                        if(obj.value){
                            if(!numChecker.test(obj.value)){
                                ret = true;
                                obj.errorText = obj.message[i+1];
                            }
                            else{
                                obj.errorText = '';
                            }
                        }
                        else{
                            obj.errorText = '';
                        }
                    }
                    //check for alphanumeric only
                    if (!ret && mechanism[0] == 'alphaNumeric') {
                        var alphaNumericChecker = /^[a-zA-Z0-9]*$/;
                        if (obj.value) {
                            if (!alphaNumericChecker.test(obj.value)) {
                                
                                obj.errorText = obj.message[i+1];
                                ret = true;
                            }
                            else {
                                obj.errorText = '';
                            }
                        }
                        else {
                            obj.errorText = '';
                        }
                    }
                    //check for char space only
                    if (!ret && mechanism[0] == 'onlyCharSpace') {
                        var charSpaceChecker = /^[a-zA-Z ]*$/;
                        if (obj.value) {
                            if (!charSpaceChecker.test(obj.value)) {  
                                obj.errorText = obj.message[i+1];
                                ret = true;
                            }
                            else {
                                obj.errorText = '';
                            }
                            obj.value = obj.value.trim();
                        }
                        else {
                            obj.errorText = '';
                        }
                    }
                    //check for carrying capacity
                    if (!ret && mechanism[0] == 'carryingCapacity') {
                        //if(code!=='IMT16'){
                        if((getSavedQuoteData.motorPolicyBasicDetails.productCode =='1801' || getSavedQuoteData.motorPolicyBasicDetails.productCode =='1802') || 
                        (getSavedQuoteData.motorPolicyBasicDetails.productCode =='1803' && getSavedQuoteData.riskDetails.vehicleTypeCode == '27')){
                            if(parseInt(getSavedQuoteData.riskDetails.seatingCapacity)<parseInt(obj.value))
                            {
                                obj.errorText = 'Number of Persons cannot be greater than seating capacity';
                                ret = true;
                            }
                            else{
                                obj.errorText='';
                            }
                        }else{
                            if(parseInt(getSavedQuoteData.riskDetails.carryingCapacity)<parseInt(obj.value))
                            {
                                obj.errorText = obj.message[i+1];
                                ret = true;
                            }
                            else{
                                obj.errorText='';
                            }
                        }
                    }
                    //check minimum value six
                    if(!ret && mechanism[0] == 'minimumValueSix'){
                        if(parseInt(obj.value)>=6)
                            {
                                obj.errorText = obj.message[i+1];
                                ret = true;
                            }
                            else{
                                obj.errorText=''
                            }
                    }
                    //check multiple of ten thousand
                    if(!ret && mechanism[0] == 'multipleTenThousand'){
                        if(parseInt(obj.value) % 10000 == 0)
                            {
                                obj.errorText=''
                            }
                            else{
                                obj.errorText = obj.message[i+1];
                                ret = true;
                            }
                    }
                    //check range of total sum insured
                    if(!ret && mechanism[0] == 'validateRange'){
                        let item = parseInt(obj.value)
                        if(getSavedQuoteData.motorPolicyBasicDetails.productCode == '1802'){
                            if(item > 100000){
                                obj.errorText = obj.message[i+1].split('/')[0];
                                ret = true;
                            }else{
                                obj.errorText = '';
                            }
                        }
                        else if(getSavedQuoteData.motorPolicyBasicDetails.productCode == '1801' || getSavedQuoteData.motorPolicyBasicDetails.productCode == '1803'){
                            if(item > 200000){
                                obj.errorText = obj.message[i+1].split('/')[1];
                                ret = true;
                            }else{
                                obj.errorText = '';
                            }
                        }
                    }
                }
            }
        }
    }
    return ret;    
}
const validateInput = function(obj, event, code){
    if(obj.validation[0]=='onlyNumber')
        onlyNumber(event, obj);
    else if(obj.validation[0]=='onlyCharSpace')
        onlyCharSpace(event,obj);
    else if(obj.validation[0]=='alphaNumericSpace')  
        alphaNumericSpace(event,obj);  
}

export default { onlyNumber, checkError, onlyCharSpace, alphaNumericSpace, isFloat, validateInput }